/** lookup を作るのに要る最小限 */
export type TruckLookupSource = {
  /** shift_truck.id。差し替え API のターゲットになる */
  id: number;
  truckId: number;
  truckNumber?: string | null;
};

/**
 * truckId から shift_truck を引く lookup を作る。
 *
 * Why 先頭優先のままにするか: 差し替え API のターゲットは「その車両の最初の delivery」
 * であり、後続で上書きすると別の shift_truck を指してしまう。**色とは規則が違う**
 * （色は最初の非 null・buildTruckColorMap 参照）ので、同じループにまとめない。
 */
export function buildTruckLookups(deliveries: TruckLookupSource[]): {
  shiftTruckByTruckId: Map<number, number>;
  shiftTruckNumberByTruckId: Map<number, string | null>;
} {
  const shiftTruckByTruckId = new Map<number, number>();
  const shiftTruckNumberByTruckId = new Map<number, string | null>();

  deliveries.forEach((d) => {
    if (shiftTruckByTruckId.has(d.truckId)) return;
    shiftTruckByTruckId.set(d.truckId, d.id);
    shiftTruckNumberByTruckId.set(d.truckId, d.truckNumber ?? null);
  });

  return { shiftTruckByTruckId, shiftTruckNumberByTruckId };
}
